import { AlertCircle, Inbox } from "lucide-react";
import { Button } from "./Button";

export function PageLoading({ label = "불러오는 중" }: { label?: string }) {
  return (
    <div
      className="grid min-h-72 place-items-center"
      role="status"
      aria-live="polite"
    >
      <div className="w-full max-w-2xl rounded-2xl bg-[var(--surface)] p-6 shadow-[0_12px_32px_var(--shadow)]">
        <p className="text-sm font-extrabold text-[var(--muted)]">{label}</p>
        <div className="loading-skeleton mt-5">
          <span className="h-5 w-2/5" />
          <span className="h-14 w-full" />
          <span className="h-14 w-[92%]" />
          <span className="h-14 w-[76%]" />
        </div>
      </div>
    </div>
  );
}

export function ErrorState({
  error,
  retry,
}: {
  error: unknown;
  retry?: () => void;
}) {
  return (
    <div className="grid min-h-64 place-items-center rounded-2xl bg-[var(--surface)] p-8 text-center shadow-[0_12px_32px_var(--shadow)]">
      <div className="grid max-w-md gap-4 justify-items-center">
        <AlertCircle className="size-8 text-[var(--danger)]" />
        <div>
          <p className="font-extrabold">데이터를 불러오지 못했습니다.</p>
          <p className="mt-1 text-sm text-[var(--muted)]">
            {error instanceof Error ? error.message : "잠시 후 다시 시도해주세요."}
          </p>
        </div>
        {retry ? <Button onClick={retry}>다시 시도</Button> : null}
      </div>
    </div>
  );
}

export function EmptyState({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div className="grid min-h-52 place-items-center rounded-2xl bg-[var(--surface-low)] p-8 text-center">
      <div className="grid max-w-md gap-2 justify-items-center">
        <Inbox className="size-8 text-[var(--muted)]" />
        <p className="font-extrabold">{title}</p>
        <p className="text-sm text-[var(--muted)]">{description}</p>
      </div>
    </div>
  );
}
